import { QueryClient } from "@tanstack/react-query";

// Shared React Query client for the whole app (Increment 4's "add a
// data-fetching layer" item). Defaults chosen for an admin dashboard:
// - refetchOnWindowFocus: false -- don't silently reload a grid (and lose
//   e.g. an in-progress filter/sort) just because the user tabbed back in.
// - retry: 1 -- a failed request (including a 401, which BaseService's
//   response interceptor turns into a sign-out) shouldn't be retried the
//   default 3x before that happens.
// - staleTime: 30s -- avoids duplicate fetches when a screen mounts more
//   than one component that reads the same query key.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30 * 1000,
    },
  },
});

export default queryClient;
